export const DividerWithLabel = ({ label }: { label?: string }) => (
  <div className="flex w-full items-center gap-3">
    {label && (
      <>
        <hr className="h-px flex-1 border-0 bg-gray-300 dark:bg-gray-500" />
        <span className="text-sm font-medium leading-tight text-secondary">
          {label}
        </span>
      </>
    )}
    <hr className="h-px flex-1 border-0 bg-gray-300 dark:bg-gray-500" />
  </div>
)
